import { log } from '@/utils/common';

const GREEDY_KEY_CODES = [
  9, // tab
  13, // enter
  27, // escape
  32, // space

];

const list = [];
let listening = false;
let dictated = false;

function checkNoMoreBeGreedy() {
  return list.length === 0;
}

function keydownHandler(evt) {
  log('greedyKeyReactor::keydownhandler', evt);
  if (GREEDY_KEY_CODES.includes(evt.keyCode)) {
    if (!dictated) {
      evt.preventDefault();
      list.forEach((n) => n(evt.keyCode));
    }
  }
}

function listen() {
  if (!listening) {
    log('greedyKeyReactor', 'listening...');
    document.addEventListener('keydown', keydownHandler, true);
    listening = true;
  }
}

function revokeListen() {
  log('greedyKeyReactor', 'revokes listening...');
  document.removeEventListener('keydown', keydownHandler, true);
  listening = false;
}

const observer = {

  subscribe(handler) {
    list.push(handler);
    listen();
    log('greedyKeyReactor::subscribe', list.length);
  },
  unsubscribe(handler) {
    log('greedyKeyReactor::unsubscribe', list.length);
    const idx = list.indexOf(handler);
    if (idx > -1) {
      list.splice(idx, 1);
      if (checkNoMoreBeGreedy()) {
        revokeListen();
      }
      log('greedyKeyReactor::unsubscribe', list.length);
    }
  },
  dictate() {
    log('greedyKeyReactor::dictate', 'dictated');
    dictated = true;
  },
  liberate() {
    log('greedyKeyReactor::dictate', 'liberated');
    dictated = false;
  },

};

export default observer;
